// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27%23999%27%3E%3Cpath d=%27M7 10l5 5 5-5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.motivation-page-container {
  padding: 20px;
  font-family: 'Rubik', sans-serif;
  margin-top: 30px;
  max-width: 1200px;
  margin: 0 auto;
}

.motivation-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.motivation-title {
  color: #333;
  margin-bottom: 10px;
  font-size: 32px;
}

.motivation-create-btn {
  background: #004D40;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 15px;
  font-size: 17px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background 0.3s;
  height: 40px;
}

.motivation-create-btn:hover {
  background: #2E7D32;
}

.motivation-filters-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 10px;
}

.motivation-search-and-filters {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-grow: 1;
}

.motivation-search-container {
  position: relative;
  flex-grow: 1;
}

.motivation-search-icon {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #999;
}

.motivation-search-bar {
  padding: 10px 15px 10px 40px;
  width: 100%;
  max-width: 400px;
  border: 1px solid #d1d5db;
  border-radius: 25px;
  background-color: #f9fafb;
  font-size: 16px;
  color: #333;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.motivation-search-bar:focus {
  border-color: #4caf50;
  box-shadow: 0 0 5px rgba(76, 175, 80, 0.5);
  outline: none;
}

.motivation-filter-dropdown {
  padding: 10px 15px;
  min-width: 180px;
  border: 1px solid #d1d5db;
  border-radius: 25px;
  background-color: #f9fafb;
  font-size: 16px;
  color: #333;
  appearance: none;
  background: #f9fafb url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right 15px center;
  background-size: 25px;
  cursor: pointer;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.motivation-filter-dropdown:focus {
  border-color: #4caf50;
  box-shadow: 0 0 5px rgba(76, 175, 80, 0.5);
  outline: none;
}

.motivation-filter-dropdown:hover {
  border-color: #4caf50;
}

.motivation-list-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.motivation-empty-state {
  padding: 40px;
  text-align: center;
  color: #666;
  font-size: 16px;
}

.motivation-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 0px;
  background-color: #ffffff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
}

.motivation-table th {
  background-color: #4caf50;
  color: #ffffff;
  padding: 12px;
  text-align: center;
  font-weight: 600;
  text-transform: uppercase;
}

.motivation-table th:hover {
  background-color: #45a049;
  cursor: pointer;
}

.motivation-table td {
  padding: 12px;
  text-align: center;
  color: #333;
  font-size: 14px;
}

.motivation-table tr:nth-child(even) {
  background-color: #f2f2f2;
}

.motivation-table tr:nth-child(odd) {
  background-color: #ffffff;
}

.motivation-table tr:hover {
  background-color: #c5eec7;
}

.motivation-message-cell {
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  padding-left: 20px !important;
}

.motivation-active-tag {
  background-color: #4caf50;
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.motivation-inactive-tag {
  background-color: #f44336;
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.motivation-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.motivation-toggle-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  color: #004D40;
  transition: all 0.2s;
}

.motivation-toggle-btn:hover {
  color: #2E7D32;
}

.motivation-edit-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  color: #2196F3;
  transition: all 0.2s;
}

.motivation-edit-btn:hover {
  color: #0d47a1;
}

.motivation-inactive-row {
  opacity: 0.8;
  background-color: #f5f5f5 !important;
}

.motivation-inactive-row:hover {
  background-color: #e0e0e0 !important;
}

.success-message-container {
  position: fixed;
  top: 70px; 
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none; 
}

.success-message17 {
  color: #155724;
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  padding: 12px 20px;
  border-radius: 15px;
  font-weight: 600;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  display: inline-flex;
  align-items: center;
  max-width: 60% !important;
  text-align: center;
  animation: fadeInOut 3s ease-in-out forwards;
}

.error-message17 {
  color: #d32f2f;
  background-color: #fde7e9;
  border: 1px solid #d32f2f;
  padding: 12px;
  border-radius: 10px;
  display: flex !important;
  align-items: center !important;
  gap: 8px;
  margin: 10px auto !important; 
  font-weight: 600;
  width: 40%;
  justify-content: center !important;
  text-align: center;
}

@keyframes fadeInOut {
  0% { opacity: 0; transform: translateY(-20px); }
  10% { opacity: 1; transform: translateY(0); }
  90% { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; transform: translateY(-20px); }
}  

.motivation-error-message {
  background-color: #ffcccc;
  color: #d32f2f;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 20px;
  text-align: center;
}

.motivation-loading {
  text-align: center;
  padding: 40px;
  font-size: 18px;
}

@media (max-width: 768px) {
  .motivation-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .motivation-filters-container {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .motivation-search-and-filters {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }
  
  .motivation-search-bar {
    max-width: 100%;
  }
  
  .motivation-table {
    display: block;
    overflow-x: auto;
  }
  
  .motivation-message-cell {
    max-width: 200px;
  }
}

.motivation-toggle-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
}

.motivation-toggle-btn.active {
  background-color: #ffebee;
  color: #c62828;
}

.motivation-toggle-btn.inactive {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.motivation-toggle-btn:hover {
  opacity: 0.8;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
  border-radius: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 22px;
  width: 22px;
  left: 4px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

input:checked + .toggle-slider {
  background-color: #4CAF50;
}

input:checked + .toggle-slider:before {
  transform: translateX(30px);
}

.toggle-loading {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255,255,255,0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s ease-in-out infinite;
  position: absolute;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.toggle-switch input:disabled + .toggle-slider {
  opacity: 0.7;
  cursor: not-allowed;
}

.toggle-switch input:disabled + .toggle-slider:before {
  opacity: 0;
}

.btn-createeee {
  display: inline-flex;
  align-items: center;
  gap: 8px;          
  justify-content: center;
  padding: 10px 15px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: -20px;
  background: #2E7D32 !important;
  color: white;
  border: none;
  height: 40px;       
}

.btn-createeee svg {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  margin-top: -5px;
}

.btn-createeee:hover {
  background: #2E7D32;
}`, "",{"version":3,"sources":["webpack://./src/styles/MotivationManagementPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,uFAAgM;EAChM,qBAAqB;EACrB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;EAChB,UAAU;EACV,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,KAAK,UAAU,EAAE,4BAA4B,EAAE;EAC/C,MAAM,UAAU,EAAE,wBAAwB,EAAE;EAC5C,MAAM,UAAU,EAAE,wBAAwB,EAAE;EAC5C,OAAO,UAAU,EAAE,4BAA4B,EAAE;AACnD;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,kBAAkB;EAClB,uBAAuB;EACvB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".motivation-page-container {\n  padding: 20px;\n  font-family: 'Rubik', sans-serif;\n  margin-top: 30px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.motivation-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n}\n\n.motivation-title {\n  color: #333;\n  margin-bottom: 10px;\n  font-size: 32px;\n}\n\n.motivation-create-btn {\n  background: #004D40;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 15px;\n  font-size: 17px;\n  font-weight: bold;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: background 0.3s;\n  height: 40px;\n}\n\n.motivation-create-btn:hover {\n  background: #2E7D32;\n}\n\n.motivation-filters-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  gap: 10px;\n}\n\n.motivation-search-and-filters {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-grow: 1;\n}\n\n.motivation-search-container {\n  position: relative;\n  flex-grow: 1;\n}\n\n.motivation-search-icon {\n  position: absolute;\n  left: 15px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #999;\n}\n\n.motivation-search-bar {\n  padding: 10px 15px 10px 40px;\n  width: 100%;\n  max-width: 400px;\n  border: 1px solid #d1d5db;\n  border-radius: 25px;\n  background-color: #f9fafb;\n  font-size: 16px;\n  color: #333;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.motivation-search-bar:focus {\n  border-color: #4caf50;\n  box-shadow: 0 0 5px rgba(76, 175, 80, 0.5);\n  outline: none;\n}\n\n.motivation-filter-dropdown {\n  padding: 10px 15px;\n  min-width: 180px;\n  border: 1px solid #d1d5db;\n  border-radius: 25px;\n  background-color: #f9fafb;\n  font-size: 16px;\n  color: #333;\n  appearance: none;\n  background: #f9fafb url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23999'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E\") no-repeat right 15px center;\n  background-size: 25px;\n  cursor: pointer;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.motivation-filter-dropdown:focus {\n  border-color: #4caf50;\n  box-shadow: 0 0 5px rgba(76, 175, 80, 0.5);\n  outline: none;\n}\n\n.motivation-filter-dropdown:hover {\n  border-color: #4caf50;\n}\n\n.motivation-list-container {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.motivation-empty-state {\n  padding: 40px;\n  text-align: center;\n  color: #666;\n  font-size: 16px;\n}\n\n.motivation-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 0px;\n  background-color: #ffffff;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.motivation-table th {\n  background-color: #4caf50;\n  color: #ffffff;\n  padding: 12px;\n  text-align: center;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.motivation-table th:hover {\n  background-color: #45a049;\n  cursor: pointer;\n}\n\n.motivation-table td {\n  padding: 12px;\n  text-align: center;\n  color: #333;\n  font-size: 14px;\n}\n\n.motivation-table tr:nth-child(even) {\n  background-color: #f2f2f2;\n}\n\n.motivation-table tr:nth-child(odd) {\n  background-color: #ffffff;\n}\n\n.motivation-table tr:hover {\n  background-color: #c5eec7;\n}\n\n.motivation-message-cell {\n  max-width: 300px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: left;\n  padding-left: 20px !important;\n}\n\n.motivation-active-tag {\n  background-color: #4caf50;\n  color: white;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.motivation-inactive-tag {\n  background-color: #f44336;\n  color: white;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.motivation-actions {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n}\n\n.motivation-toggle-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 18px;\n  color: #004D40;\n  transition: all 0.2s;\n}\n\n.motivation-toggle-btn:hover {\n  color: #2E7D32;\n}\n\n.motivation-edit-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 18px;\n  color: #2196F3;\n  transition: all 0.2s;\n}\n\n.motivation-edit-btn:hover {\n  color: #0d47a1;\n}\n\n.motivation-inactive-row {\n  opacity: 0.8;\n  background-color: #f5f5f5 !important;\n}\n\n.motivation-inactive-row:hover {\n  background-color: #e0e0e0 !important;\n}\n\n.success-message-container {\n  position: fixed;\n  top: 70px; \n  left: 0;\n  right: 0;\n  z-index: 1000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  pointer-events: none; \n}\n\n.success-message17 {\n  color: #155724;\n  background-color: #d4edda;\n  border: 1px solid #c3e6cb;\n  padding: 12px 20px;\n  border-radius: 15px;\n  font-weight: 600;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  display: inline-flex;\n  align-items: center;\n  max-width: 60% !important;\n  text-align: center;\n  animation: fadeInOut 3s ease-in-out forwards;\n}\n\n.error-message17 {\n  color: #d32f2f;\n  background-color: #fde7e9;\n  border: 1px solid #d32f2f;\n  padding: 12px;\n  border-radius: 10px;\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px;\n  margin: 10px auto !important; \n  font-weight: 600;\n  width: 40%;\n  justify-content: center !important;\n  text-align: center;\n}\n\n@keyframes fadeInOut {\n  0% { opacity: 0; transform: translateY(-20px); }\n  10% { opacity: 1; transform: translateY(0); }\n  90% { opacity: 1; transform: translateY(0); }\n  100% { opacity: 0; transform: translateY(-20px); }\n}  \n\n.motivation-error-message {\n  background-color: #ffcccc;\n  color: #d32f2f;\n  padding: 10px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.motivation-loading {\n  text-align: center;\n  padding: 40px;\n  font-size: 18px;\n}\n\n@media (max-width: 768px) {\n  .motivation-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 15px;\n  }\n  \n  .motivation-filters-container {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .motivation-search-and-filters {\n    width: 100%;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .motivation-search-bar {\n    max-width: 100%;\n  }\n  \n  .motivation-table {\n    display: block;\n    overflow-x: auto;\n  }\n  \n  .motivation-message-cell {\n    max-width: 200px;\n  }\n}\n\n.motivation-toggle-btn {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 14px;\n}\n\n.motivation-toggle-btn.active {\n  background-color: #ffebee;\n  color: #c62828;\n}\n\n.motivation-toggle-btn.inactive {\n  background-color: #e8f5e9;\n  color: #2e7d32;\n}\n\n.motivation-toggle-btn:hover {\n  opacity: 0.8;\n}\n\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 30px;\n}\n\n.toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: .4s;\n  border-radius: 34px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 22px;\n  width: 22px;\n  left: 4px;\n  background-color: white;\n  transition: .4s;\n  border-radius: 50%;\n}\n\ninput:checked + .toggle-slider {\n  background-color: #4CAF50;\n}\n\ninput:checked + .toggle-slider:before {\n  transform: translateX(30px);\n}\n\n.toggle-loading {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255,255,255,0.3);\n  border-radius: 50%;\n  border-top-color: white;\n  animation: spin 1s ease-in-out infinite;\n  position: absolute;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.toggle-switch input:disabled + .toggle-slider {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.toggle-switch input:disabled + .toggle-slider:before {\n  opacity: 0;\n}\n\n.btn-createeee {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;          \n  justify-content: center;\n  padding: 10px 15px;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-bottom: -20px;\n  background: #2E7D32 !important;\n  color: white;\n  border: none;\n  height: 40px;       \n}\n\n.btn-createeee svg {\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n  margin-top: -5px;\n}\n\n.btn-createeee:hover {\n  background: #2E7D32;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
